import { BoxProps } from '@chakra-ui/react';
import { SingleDatepicker } from 'chakra-dayzed-datepicker';
import { FieldError } from 'features';
import { Controller, ControllerProps } from 'react-hook-form';

export interface DatePickerProps extends BoxProps {}

export const DatePicker = (
  props: DatePickerProps & Omit<ControllerProps<any>, 'render'>
) => {
  return (
    <Controller
      {...props}
      render={({ field }) => {
        const { ref, ...other } = field;

        return (
          <>
            <SingleDatepicker
              {...props} // TODO: remove if this causes problems
              {...other}
              configs={{
                dateFormat: 'MM/dd/yyyy',
              }}
              name={field.name}
              date={field.value && new Date(field.value)}
              onDateChange={(value) => {
                field.onChange(value);
              }}
            />
            <FieldError name={props.name} />
          </>
        );
      }}
    />
  );
};
